"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureStore = void 0;

var configureStore = function () {
  return process.env.NODE_ENV === 'development' && process.env.REACT_APP_TARGET === 'web' ? require('./configureStore.debug').default : require('./configureStore.main').default;
}();

exports.configureStore = configureStore;
//# sourceMappingURL=index.js.map